<header class="border-bottom fix-header"  *ngIf="!isMobileDevice">
  <div class="container">
    <div class="d-flex flex-wrap align-items-center  justify-content-lg-start justify-content-md-start">
      <a  title="Starbucks Logo" class="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none"
        [routerLink]="['/ordering']">
        <img src="assets/icon/logo.png" alt="Logo" class="logo">
      </a>
      <ul class="nav col-12  col-md-auto col-lg-auto me-lg-auto mb-2  mb-md-0">
        <li routerLinkActive="active">
          <a (click)="topNavigationGA('Order')" [routerLink]="['/ordering']" class="nav-link link-dark">Order</a>
        </li>
      </ul>
      <div class="col-12  col-md-auto  col-lg-auto mb-3 mb-lg-0 me-lg-3 search-none">
        <div class="search-form"> <img src="assets/icon/search.svg" class="fa-search" alt="search" [routerLink]="['/search']">
          <input type="text" class="form-control form-input custom-search-box" placeholder="Looking for something specific?" (keyup)="getAutoSearchList($event,search.value)" (keyup.enter)="searchKey(search.value)" #search [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let suggestion of autoSuggestionArry" [value]="suggestion" (click)="searchKey(suggestion)">
              {{suggestion}}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="dropdown text-end profile-icon">
        <a class="d-block link-dark text-decoration-none" id="dropdownUser1" data-bs-toggle="dropdown"
          aria-expanded="false" [routerLink]="['/profile']">
          <img src="assets/icon/account_thin.svg" alt="profile icon" width="32" height="32" class="rounded-circle"
          (click)="profileClickGA()">
        </a>
      </div>
    </div>
  </div>
</header>
